// GENERAL
export const APP_VERSION = '0.1.4a';

// PHOTON
// connection
export const PHOTON_TEST_APP_ID = '7b0e99b9-7f35-4fad-b324-c0b4218fc2c0'; // TODO: NextJS env var
export const PHOTON_APP_VERSION = '1.0';
export const PHOTON_REGION = 'us';
export const PHOTON_CONNECTION_TIMEOUT = 10 * 1000;
// stats
export const POLLING_PHOTON_STATS_SECONDS = 3;
// lobby
export const POLLING_INTERVAL_WAITING_PLAYER_SECONDS = 3;
// client auto-disconnect
export const OFFLINE_THRESHOLD_MINUTES = 5;

// GAMES
export const DEFAULT_DURATION_EACH_PLAYER_MINUTES = 15;
export const MIN_DURATION_EACH_PLAYER_MINUTES = 5;
export const PHOTON_PING_INTERVAL_SECONDS = 10;
export const SEPARATOR_PRIVATE_ROOMS = ':';
export const SEPARATOR_PUBLIC_ROOMS = '_';
export const SEPARATOR_REMATCH_ROOM_COUNT = '#';
export const SEPARATOR_PING_DATA = '~';
// timers
export const THRESHOLD_TIMERS_RESYNCH_SECONDS = 1;
export const THRESHOLD_TIMERS_WARNING_SECONDS = 30;
export const LOW_TIME_UI_MSG_BELOW_SECONDS = 60;
// player status for online indicator
export const CHECK_OPPENENT_ONLINE_EVERY_SECONDS = 3;
export const OPPONENT_CONSIDERED_OFFLINE_AFTER_SECONDS = 30;
// offline status for match result
export const OFFLINE_CHECKS_INTERVAL_SECONDS = 3;
export const CONSIDERED_OFFLINE_AFTER_MINS = 3;

export const CHESS_PIECE = {
  // White
  p: '♙', r: '♖', n: '♘', b: '♗', q: '♕', k: '♔',
  // Black
  P: '♟', R: '♜', N: '♞', B: '♝', Q: '♛', K: '♚',
};

// LOGS
export const USER_MSG_PREFIX = 'usermsg::'; // chat messages
export const REMATCH_MSG_PREFIX = 'rematchmsg::'; // rematch request

// LOBBY
export const WAIT_JOIN_ROOM_SECONDS = 5;
export const WAIT_NEW_ROOM_IN_LOBBY_SECONDS = 10;
